@if (visitStore.loading | async) {
<mat-progress-bar mode="indeterminate"></mat-progress-bar>
}

<!--<mat-toolbar color="primary">-->
<!--  <mat-radio-group aria-label="Visit Status">-->
<!--    <mat-radio-button value="REFERRED" [checked]="true" (click)="referMode()">Referred Visits</mat-radio-button>-->
<!--    <mat-radio-button value="NEW" (click)="newMode()">New Unbooked Visits</mat-radio-button>-->
<!--  </mat-radio-group>-->

<!--</mat-toolbar>-->
<mat-tab-group (selectedTabChange)="tabChange($event)" [preserveContent]="true" backgroundColor="accent"
  [mat-align-tabs]="'center'" [mat-stretch-tabs]="false">
  <!--  <mat-tab label="Live">-->
  <!--    <ng-template mat-tab-label>-->
  <!--      <span [matBadge]="followOnCount" matBadgeOverlap="false">Follow On Required</span>-->
  <!--    </ng-template>-->

  <!--    <app-follow-on-tool [fullPageMode]="true" (onAlertCount)="followOnCount = $event"></app-follow-on-tool>-->
  <!--  </mat-tab>-->
  <mat-tab class="tab-background" label="Referred">


  </mat-tab>
  <mat-tab class="tab-background" label="New">
    <!--    <app-visit-job-table-viewer #newVisitTableViewer (gridChanged)="gridChanged()" [columns]="columns" ></app-visit-job-table-viewer>-->

  </mat-tab>
</mat-tab-group>
<app-visit-table-viewer #visitTableViewer (gridChanged)="gridChanged()" [columns]="columns"></app-visit-table-viewer>